// Centralized application constants
export const REPORT_TYPE_MONTHLY = 'Monthly';
export const REPORT_TYPE_FUNDER = 'Funder';
export const REPORT_TYPE_OPTIONS = [REPORT_TYPE_MONTHLY, REPORT_TYPE_FUNDER];

export const DEFAULT_PREFETCH_THRESHOLD = 0.7;
export const SCROLL_DEBOUNCE_MS = 150;

export const EXCEL_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const MONTHLY_EXCEL_FILENAME = 'Monthly Financial Summary.xlsx';
export const FUNDER_EXCEL_FILENAME = 'Funder Financial Summary.xlsx';

// UI label constants
export const LABEL_DATE_RANGE = 'Date Range';
export const LABEL_LOCATION = 'Location';
export const LABEL_FUNDER = 'Funder';
export const LABEL_PREVIOUS_PERIOD = 'Previous Period';
export const LABEL_TOTAL = 'TOTAL';

export class ReportConstants {
	public static readonly AllLocations = 'All';
	public static readonly AllFunders = 'All';
}

export const CLAIMS_GLOBAL_SEARCH_STATE_KEY = 'claimsGlobalSearchState';
